import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export const GAUGE_CONFIG = {
  angle: 0,
  lineWidth: 0.2,
  radiusScale: 0.82,
  pointer: {
    length: 0.5,
    strokeWidth: 0.035,
    color: '#212529',
  },
  staticZones: [
    { strokeStyle: '#236e27', min: 0, max: 3 }, // Green from 0 to 70
    { strokeStyle: '#d2a92a', min: 3, max: 4 }, // Yellow
    { strokeStyle: '#b6351e', min: 4, max: 6 }, // Red
  ],
  limitMax: true,
  limitMin: true,
  colorStart: '#6FADCF',
  colorStop: '#8FC0DA',
  strokeColor: '#E0E0E0',
  generateGradient: true,
  highDpiSupport: true,
};

@Injectable({ providedIn: 'root' })
export class IndicatorGaugeConfigService {
  getConfig(): Observable<object> {
    const config = GAUGE_CONFIG;
    return of(config);
  }
}
